import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    head: {
      padding: [24, 16, 30],
      display: "flex",
      flexDirection: "column",
      [theme.breakpoints.up("mobile")]: {
        padding: [42, 24, 50],
      },
    },
    title: {
      margin: [0, "auto", 15, "auto"],
    },
    contentReadMore: {
      width: 300,
    },
    description: {
      margin: [0, "auto"],
      maxWidth: 710,
    },
  }),
  { name: "PageHeader" },
);
